import React, { useEffect, useState } from 'react'
import { Button } from 'antd'
import { LogoutOutlined } from '@ant-design/icons'
import httpRequest from '../../services/http-request'
import { navigate, Link } from '@reach/router'

import LoadingSpinner from '../common/loading-spinner'

const PLReportByMarket = (props) => {
  const signedValueSpan = (value) => {
    if (value < 0) {
      return (
        <span className="value-span value-span--value-negative">
          {parseFloat(value).toFixed(2)}
        </span>
      )
    } else {
      return (
        <span className="value-span value-span--value-positive">
          {parseFloat(value).toFixed(2)}
        </span>
      )
    }
  }

  const [loading, setLoading] = useState(false)
  const [userName, setUserName] = useState('')

  useEffect(() => {
    const userRole = localStorage.getItem('role')
    const loggedUserName = localStorage.getItem('userName')

    if (!userRole || !loggedUserName) {
      props.navigate('/login')
    }

    setUserName(loggedUserName)
  }, [])

  const handleLogoutClick = () => {
    localStorage.removeItem('role')
    localStorage.removeItem('token')
    navigate('/login')
  }

  const [marketAnalysis, setMarketAnalysis] = useState([])
  const [topWinners, setTopWinners] = useState([])

  const groupByIp = (arr) => {
    const result = arr.reduce((acc, curr) => {
      const ipRecord = acc.find((i) => i.IP === curr.IP)
      if (ipRecord) {
        ipRecord.records.push(curr)
      } else {
        acc.push({
          IP: curr.IP,
          records: [curr],
        })
      }

      return acc
    }, [])
    return result
  }

  useEffect(() => {
    const fetchMarketAnalysis = async () => {
      try {
        setLoading(true)
        const response = await httpRequest(
          `/api/reports/getMarketAnalysis?marketId=${props.marketId}`,
          'GET'
        )
        console.log(response)
        const groupedIps = groupByIp(response.data.result)
        setMarketAnalysis(groupedIps)
        setLoading(false)
      } catch (error) {
        console.log(error)
        setLoading(false)
      }
    }
    fetchMarketAnalysis()
  }, [])

  const [topWinnersLoading, setTopWinnersLoading] = useState(false)

  useEffect(() => {
    const fetchTopWinners = async () => {
      try {
        setTopWinnersLoading(true)
        const response = await httpRequest(
          `/api/reports/getTopWinner?marketId=${props.marketId}`,
          'GET'
        )
        console.log(response)
        setTopWinners(response.data.result)
        setTopWinnersLoading(false)
      } catch (error) {
        console.log(error)
        setTopWinnersLoading(false)
      }
    }
    fetchTopWinners()
  }, [])

  return (
    <>
      <div className="page-container">
        <div className="header">
          <div className="header__title">
            <h2>Market Analysis</h2>
            <span></span>
            {/* <span>
              <CSVLink
                data={[]}
                filename={`pl-report-by-market-bets-${new Date().getTime()}.csv`}
              >
                <Button type="primary">Download CSV</Button>
              </CSVLink>
            </span> */}
            <span className="header-span--pull-right">
              <span className="user-name">{userName}</span>
              <Button onClick={handleLogoutClick} type="primary" size="small">
                Logout <LogoutOutlined />
              </Button>
            </span>
          </div>

          <div className="header__filters">
            <Link to="/pl-report-by-market">Markets</Link> &nbsp; &gt;
            {` ${props.marketId}`}
          </div>
        </div>
        {!topWinnersLoading && (
          <div className="data-grid">
            <table>
              <thead>
                <tr>
                  <th className="row-header row-header--left">Login name</th>
                  <th className="row-header row-header--left">Member code</th>
                  <th className="row-header row-header--right">Winning</th>
                </tr>
              </thead>
              <tbody>
                {topWinners.map((row) => (
                  <>
                    <tr className="row-details row-name">
                      <td colSpan={2}>{Object.keys(row)[0]}</td>
                    </tr>
                    {row[Object.keys(row)[0]].map((r) => (
                      <tr>
                        <td className="row-data row-data--bold row-data--left">
                          {r.LOGIN_NAME}
                        </td>
                        <td className="row-data row-data--bold row-data--left">
                          {r.MEMBER_CODE}
                        </td>
                        <td className="row-data row-data--right ">
                          {signedValueSpan(r.WINNING)}
                        </td>
                      </tr>
                    ))}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {topWinnersLoading && <LoadingSpinner text="Loading: Top winners" />}

        {!loading && (
          <div className="data-grid">
            <table>
              <thead>
                <tr>
                  <th className="row-header row-header--left">Member</th>

                  <th className="row-header row-header--right">Winning</th>
                  <th className="row-header row-header--left">
                    No. of other markets
                  </th>
                </tr>
              </thead>
              <tbody>
                {marketAnalysis.map((row) => (
                  <>
                    <tr className="row-details row-name">
                      <td colSpan={1}>{row.IP}</td>
                      <td colSpan={3}>
                        Common IP Users: {row.records[0].PL_Common_IP_All_Users}
                      </td>
                    </tr>
                    {row.records.map((r) => (
                      <tr>
                        <td className="row-data row-data--bold row-data--left">
                          {r.Member_Code}
                        </td>

                        <td className="row-data row-data--right ">
                          {signedValueSpan(r.PL_Common_IP_This_User)}
                        </td>
                        <td className="row-data row-data--left ">
                          {r.No_Txn_Market}
                        </td>
                      </tr>
                    ))}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {loading && <LoadingSpinner text="Loading: Market Analysis" />}
      </div>
    </>
  )
}

export default PLReportByMarket
